import { render } from "./ThreeColumn.vue?vue&type=template&id=609b5c89"
import script from "./ThreeColumn.vue?vue&type=script&lang=js"
export * from "./ThreeColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__